import { BASE_API_URL } from "@/utils/Constants";
import { createConsumer, Consumer, Subscription } from "@rails/actioncable";
import { Action, Module, Mutation, VuexModule } from "vuex-module-decorators";

@Module({
  namespaced: true,
  name: "cable",
})
export default class Cable extends VuexModule {
  private _consumer: Consumer | undefined = undefined;

  get consumer() {
    return this._consumer;
  }

  @Mutation
  init(token: string) {
    if (this._consumer) {
      return;
    }
    this._consumer = createConsumer(`${BASE_API_URL}ws?token=${token}`);
  }

  @Mutation
  disconnect() {
    this._consumer?.disconnect();
    this._consumer = undefined;
  }

  @Action({ rawError: true })
  subscribe<T>({
    params,
    handler,
  }: {
    params: any;
    handler: T;
  }): Promise<T & Subscription> {
    return new Promise((resolve, reject) => {
      const token = this.context.rootGetters["accessToken"];
      const { commit } = this.context;

      commit("init", token);

      const subscription = this.context.getters.consumer.subscriptions.create(
        params,
        {
          ...handler,
          connected() {
            resolve(subscription);
            if ("connected" in handler) {
              (handler as any).connected();
            }
          },
          rejected() {
            if ("rejected" in handler) {
              (handler as any).rejected();
            }
            reject(new Error("Connection rejected"));
          },
        }
      );
    });
  }
}
